(function () {
  if (window.netstepsPdpSizePickerInit) return;
  window.netstepsPdpSizePickerInit = true;

  var strings = (window.auroraThemeLocales && window.auroraThemeLocales.variantStrings) || {};
  var SELECT_SIZE_LABEL = strings.selectSize || 'Select size';
  var SELECT_DENOMINATION_LABEL = strings.selectDenomination || 'Select denomination';
  var ADD_TO_CART_LABEL = strings.addToCart || 'Add to cart';
  var SOLD_OUT_LABEL = strings.soldOut || 'Sold out';

  var VARIANT_PICKER_BLOCK_ID = 'variant_picker';
  var PRODUCT_BLOCK_ATTR = 'data-product-block';
  var MEDIA_SELECTOR = '[data-product-media-carousel-component]';

  function stripVariantFromUrl() {
    if (!window.history || !window.URL) return;

    var url = new URL(window.location.href);
    if (!url.searchParams.has('variant')) return;

    url.searchParams.delete('variant');
    window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
  }

  function getVariantPicker() {
    return document.querySelector('variant-picker[data-require-size-selection]');
  }

  function getSizeStorageKey(picker) {
    if (!picker || !picker.dataset.productId) return null;
    return 'netsteps-pdp-size-value-' + picker.dataset.productId;
  }

  function getSizeOptionName(picker) {
    return (picker && picker.dataset.sizeOptionName) || 'Size';
  }

  function isGiftCardPicker(picker) {
    return Boolean(picker && picker.hasAttribute('data-gift-card'));
  }

  function getSelectionPromptLabel(picker) {
    if (isGiftCardPicker(picker)) return SELECT_DENOMINATION_LABEL;
    return SELECT_SIZE_LABEL;
  }

  function optionNameMatchesSize(optionName, picker) {
    if (isGiftCardPicker(picker)) return true;

    var target = getSizeOptionName(picker).toLowerCase().trim();
    var name = (optionName || '').toLowerCase().trim();

    if (target && name === target) return true;
    if (!target || target === 'size') {
      return name === 'size' || name.indexOf('μεγεθ') !== -1 || name.indexOf('megeth') !== -1;
    }

    return false;
  }

  function getSizeOptionIndex(picker) {
    var labelContainers = picker.querySelectorAll('[data-variant-picker-option-labels]');

    for (var i = 0; i < labelContainers.length; i++) {
      var optionName = labelContainers[i].getAttribute('option-picker-name') || '';
      if (optionNameMatchesSize(optionName, picker)) return i;
    }

    for (var j = 0; j < labelContainers.length; j++) {
      if (labelContainers[j].querySelector('.product-variant-picker__pill-list')) return j;
    }

    return -1;
  }

  function getSizeOptionInputGroup(picker) {
    var index = getSizeOptionIndex(picker);
    if (index < 0) return null;

    var formGroups = picker.querySelectorAll(
      '.product-variant-picker__form [data-variant-picker-option-inputs]'
    );
    return formGroups[index] || null;
  }

  function getSizeInputs(picker) {
    var inputGroup = getSizeOptionInputGroup(picker);
    if (!inputGroup) return [];

    return Array.prototype.slice.call(inputGroup.querySelectorAll('input[type="radio"]'));
  }

  function getCheckedSizeInput(picker) {
    return getSizeInputs(picker).find(function (input) {
      return input.checked;
    });
  }

  function hasSizeSelection(picker) {
    return Boolean(getCheckedSizeInput(picker));
  }

  function isAllSizesSoldOut(picker) {
    if (picker && picker.dataset.allSizesSoldOut === 'true') return true;

    var form = getProductForm();
    if (form && form.hasAttribute('data-all-sizes-sold-out')) return true;

    var variants = getVariants(picker);
    if (!variants.length) return false;

    return variants.every(function (variant) {
      return !variant.available;
    });
  }

  function setSoldOutButtons(form, buttons) {
    form.removeAttribute('data-awaiting-size-selection');
    setButtonsSubmitMode(form, true);

    var variantInput = form.querySelector('[data-product-form-variant]');
    if (variantInput) variantInput.value = '';

    buttons.forEach(function (button) {
      button.disabled = true;
      button.setAttribute('aria-label', SOLD_OUT_LABEL);
      setButtonLabel(button, SOLD_OUT_LABEL);
    });
  }

  function getOptionInputGroups(picker) {
    return Array.prototype.slice.call(
      picker.querySelectorAll('.product-variant-picker__form [data-variant-picker-option-inputs]')
    );
  }

  function getCheckedOptionValues(picker) {
    return getOptionInputGroups(picker).map(function (group) {
      var checked = group.querySelector('input[type="radio"]:checked');
      return checked ? checked.value : null;
    });
  }

  function getSizeOptionLabelContainer(picker) {
    var index = getSizeOptionIndex(picker);
    if (index < 0) return null;

    return picker.querySelectorAll('[data-variant-picker-option-labels]')[index] || null;
  }

  function syncSizePillLabels(picker) {
    var container = getSizeOptionLabelContainer(picker);
    if (!container) return;

    var checked = getCheckedSizeInput(picker);

    container.querySelectorAll('label.pill').forEach(function (label) {
      var inputId = label.getAttribute('for');
      var input = inputId ? document.getElementById(inputId) : null;
      var isSelected = Boolean(input && input === checked);

      label.classList.toggle('selected', isSelected);
      if (isSelected) {
        label.setAttribute('tabindex', '0');
      } else {
        label.removeAttribute('tabindex');
      }
    });
  }

  function getVariants(picker) {
    var script = picker.querySelector('[data-product-variants-json]');
    if (!script) return [];

    try {
      return JSON.parse(script.textContent) || [];
    } catch (error) {
      return [];
    }
  }

  function getSelectedVariantFromJson(picker) {
    var script = picker.querySelector('[data-selected-variant-json]');
    if (!script) return null;

    try {
      var variant = JSON.parse(script.textContent);
      return variant && variant.id ? variant : null;
    } catch (error) {
      return null;
    }
  }

  function variantMatchesCheckedOptions(variant, optionValues) {
    for (var i = 0; i < optionValues.length; i++) {
      if (optionValues[i] === null) continue;

      var optionKey = 'option' + (i + 1);
      if (variant[optionKey] !== optionValues[i]) return false;
    }

    return true;
  }

  function findSelectedVariant(picker) {
    if (!hasSizeSelection(picker)) return null;

    var optionValues = getCheckedOptionValues(picker);
    var variants = getVariants(picker);
    var matched = null;

    for (var i = 0; i < variants.length; i++) {
      if (variantMatchesCheckedOptions(variants[i], optionValues)) {
        matched = variants[i];
        break;
      }
    }

    if (matched) return matched;

    var fromJson = getSelectedVariantFromJson(picker);
    if (fromJson && variantMatchesCheckedOptions(fromJson, optionValues)) {
      return fromJson;
    }

    return null;
  }

  function getSingleSizeInput(picker) {
    var inputs = getSizeInputs(picker);
    return inputs.length === 1 ? inputs[0] : null;
  }

  function autoSelectSingleSize(picker) {
    var single = getSingleSizeInput(picker);
    if (!single) return false;

    if (!single.checked) {
      single.checked = true;
      syncSizePillLabels(picker);
    }

    return true;
  }

  function rememberSizeSelection(picker) {
    var checked = getCheckedSizeInput(picker);
    var key = getSizeStorageKey(picker);
    if (!checked || !key) return;

    window.sessionStorage.setItem(key, checked.value);
  }

  function clearSizeSelection(picker) {
    getSizeInputs(picker).forEach(function (input) {
      input.checked = false;
    });
  }

  function getProductForm() {
    var picker = getVariantPicker();
    if (!picker) return null;

    var section = picker.closest('.shopify-section') || document;
    return section.querySelector('product-form');
  }

  function scheduleStickyBuyUpdate() {
    if (typeof window.netstepsStickyBuyUpdate === 'function') {
      window.requestAnimationFrame(window.netstepsStickyBuyUpdate);
    }
  }

  function getSubmitButtons(form) {
    if (!form) return [];
    return Array.prototype.slice.call(
      form.querySelectorAll('.product-form__btn-wrapper button[name="add"]')
    );
  }

  function setButtonsSubmitMode(form, isSubmit) {
    getSubmitButtons(form).forEach(function (button) {
      button.type = isSubmit ? 'submit' : 'button';
    });
  }

  function setButtonLabel(button, label) {
    var textNode = button.querySelector('[data-button-text]');
    if (!textNode) return;

    var longLabel = textNode.querySelector('.product-buy-btn__text-label');
    var shortLabel = textNode.querySelector('.product-buy-btn__text-label-short');

    if (longLabel || shortLabel) {
      if (longLabel) longLabel.textContent = ' ' + label;
      if (shortLabel) shortLabel.textContent = ' ' + label;
      return;
    }

    textNode.textContent = label;
  }

  function applyVariantToForm(picker, variant) {
    var form = getProductForm();
    if (!form) return '';

    var variantInput = form.querySelector('[data-product-form-variant]');
    if (!variantInput) return '';

    var resolved = variant || findSelectedVariant(picker);
    if (!resolved || !resolved.id) return '';

    variantInput.value = String(resolved.id);
    variantInput.disabled = false;

    return String(resolved.id);
  }

  function updateBuyButtons() {
    var picker = getVariantPicker();
    var form = getProductForm();
    if (!picker || !form) return;

    var buttons = getSubmitButtons(form);

    if (isAllSizesSoldOut(picker)) {
      setSoldOutButtons(form, buttons);
      scheduleStickyBuyUpdate();
      return;
    }

    var variant = findSelectedVariant(picker);
    var variantId = variant ? String(variant.id) : '';
    var isAvailable = Boolean(variant && variant.available);

    if (!hasSizeSelection(picker) && !variantId) {
      form.setAttribute('data-awaiting-size-selection', '');
      setButtonsSubmitMode(form, false);

      buttons.forEach(function (button) {
        button.disabled = false;
        button.setAttribute('aria-label', getSelectionPromptLabel(picker));
        setButtonLabel(button, getSelectionPromptLabel(picker));
      });
      scheduleStickyBuyUpdate();
      return;
    }

    if (variantId) {
      applyVariantToForm(picker, variant);
    }

    form.removeAttribute('data-awaiting-size-selection');
    setButtonsSubmitMode(form, true);

    buttons.forEach(function (button) {
      if (!variantId) {
        button.disabled = true;
        button.setAttribute('aria-label', getSelectionPromptLabel(picker));
        setButtonLabel(button, getSelectionPromptLabel(picker));
        return;
      }

      button.disabled = !isAvailable;
      button.setAttribute('aria-label', isAvailable ? ADD_TO_CART_LABEL : SOLD_OUT_LABEL);
      setButtonLabel(button, isAvailable ? ADD_TO_CART_LABEL : SOLD_OUT_LABEL);
    });

    scheduleStickyBuyUpdate();
    if (typeof window.netstepsGiftCardUpdateButtons === 'function') {
      window.netstepsGiftCardUpdateButtons();
    }
  }

  function revealSizePicker(button) {
    if (!button || !button.closest('product-form-button')) return;

    var picker = getVariantPicker();
    if (!picker) return;

    var target = getSizeOptionLabelContainer(picker) || picker;
    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function handleAwaitingSizeButtonClick(event) {
    var button = event.target.closest('product-form[data-awaiting-size-selection] button[name="add"]');
    if (!button || button.type !== 'button') return;

    event.preventDefault();
    event.stopPropagation();
    revealSizePicker(button);
  }

  function syncStoreAvailability(picker) {
    var variant = findSelectedVariant(picker);
    if (!variant || !hasSizeSelection(picker)) return;

    var existing = document.querySelector('pickup-availability');
    if (existing) {
      if (existing.dataset.variantId !== String(variant.id) && typeof existing.fetchAvailability === 'function') {
        existing.dataset.variantId = String(variant.id);
        existing.fetchAvailability();
      }
      return;
    }

    var button = document.querySelector('[data-store-availability-awaiting-size]');
    if (!button) return;

    var wrapper = button.closest('.pickup-availability') || button.parentElement;
    var element = document.createElement('pickup-availability');
    element.className = 'pickup-availability body-font-weight-from-global-settings';
    element.dataset.baseUrl = button.getAttribute('data-pickup-base-url') || '/';
    element.dataset.variantId = String(variant.id);
    element.dataset.hasOnlyDefaultVariant = 'false';

    var content = document.createElement('pickup-availability-content');
    content.className = 'pickup-availability-info';
    button.removeAttribute('data-store-availability-awaiting-size');
    content.appendChild(button);
    element.appendChild(content);
    wrapper.replaceWith(element);
    if (typeof element.fetchAvailability === 'function') element.fetchAvailability();
  }

  function handleStoreAvailabilityBeforeSize(event) {
    var trigger = event.target.closest('[data-store-availability-awaiting-size]');
    if (!trigger) return;

    var picker = getVariantPicker();
    if (!picker || hasSizeSelection(picker)) return;

    event.preventDefault();
    var message = trigger.parentElement.querySelector('[data-store-availability-size-message]');
    if (message) message.hidden = false;
    picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function enforceNoDefaultSizeSelection() {
    var picker = getVariantPicker();
    if (!picker || !picker.dataset.productId) return;

    window.netstepsPdpEnforcedProducts = window.netstepsPdpEnforcedProducts || {};
    if (window.netstepsPdpEnforcedProducts[picker.dataset.productId]) return;

    window.netstepsPdpEnforcedProducts[picker.dataset.productId] = true;

    if (isAllSizesSoldOut(picker)) {
      updateBuyButtons();
      return;
    }

    if (autoSelectSingleSize(picker)) {
      updateBuyButtons();
      return;
    }

    var sizeKey = getSizeStorageKey(picker);
    if (sizeKey) window.sessionStorage.removeItem(sizeKey);

    clearSizeSelection(picker);
    updateBuyButtons();
  }

  function handleVariantChange(event) {
    if (!event.target.matches('input[type="radio"]')) return;

    var picker = event.target.closest('variant-picker[data-require-size-selection]');
    if (!picker) return;

    var sizeInputs = getSizeInputs(picker);
    if (sizeInputs.indexOf(event.target) === -1) return;

    rememberSizeSelection(picker);
    syncSizePillLabels(picker);
    updateBuyButtons();
  }

  function buildPdpFetchUrl(picker) {
    var selectedOptionsIds = getOptionInputGroups(picker)
      .map(function (group) {
        var checked = group.querySelector('input[type="radio"]:checked');
        return checked ? checked.dataset.valueId : '';
      })
      .filter(Boolean);

    var params =
      selectedOptionsIds.length > 0 ? 'option_values=' + selectedOptionsIds.join(',') : '';

    return (
      picker.dataset.url +
      '?section_id=' +
      picker.dataset.sectionIdWithoutPrefix +
      '&' +
      params
    );
  }

  function patchVariantPicker() {
    if (!window.customElements || !window.customElements.whenDefined) return;

    window.customElements.whenDefined('variant-picker').then(function () {
      var Proto = window.customElements.get('variant-picker').prototype;
      if (!Proto || Proto.__netstepsPatched) return;
      Proto.__netstepsPatched = true;

      var originalGetFetchUrl = Proto.getFetchUrl;
      var originalUpdateElements = Proto.updateElements;

      Proto.getFetchUrl = function (clickedInputEl) {
        if (!this.hasAttribute('data-require-size-selection')) {
          return originalGetFetchUrl.call(this, clickedInputEl);
        }

        return buildPdpFetchUrl(this);
      };

      Proto.updateElements = function (html, shouldSwapProduct) {
        if (!this.hasAttribute('data-require-size-selection')) {
          originalUpdateElements.call(this, html, shouldSwapProduct);
          return;
        }

        var section = this.closest('.shopify-section');
        if (!section || !html) {
          originalUpdateElements.call(this, html, shouldSwapProduct);
          return;
        }

        if (shouldSwapProduct) {
          section.querySelectorAll(MEDIA_SELECTOR).forEach(function (block) {
            var newBlock = html.querySelector(MEDIA_SELECTOR);
            if (newBlock) block.replaceWith(newBlock);
          });
        }

        section.querySelectorAll('[' + PRODUCT_BLOCK_ATTR + ']').forEach(function (block) {
          var blockId = block.getAttribute(PRODUCT_BLOCK_ATTR);
          if (blockId === VARIANT_PICKER_BLOCK_ID) return;

          var newBlock = html.querySelector('[' + PRODUCT_BLOCK_ATTR + '="' + blockId + '"]');
          if (newBlock) block.replaceWith(newBlock);
        });

        var newPicker = html.querySelector('variant-picker');
        if (newPicker) {
          var selectedJson = newPicker.querySelector('[data-selected-variant-json]');
          var currentSelectedJson = this.querySelector('[data-selected-variant-json]');
          if (selectedJson && currentSelectedJson) {
            currentSelectedJson.textContent = selectedJson.textContent;
          }

          // Keep theme behavior: update ?variant= in URL when selection changes.
          // We intentionally don't call the original updateElements(), because it
          // would swap the size picker DOM and re-introduce selection flicker.
          this.updateURL(newPicker);
        }

        updateBuyButtons();
        syncStoreAvailability(this);
        if (this.hasAttribute('data-gift-card')) {
          window.requestAnimationFrame(function () {
            document.dispatchEvent(new Event('shopify:section:load'));
          });
        }
      };
    });
  }

  function init() {
    stripVariantFromUrl();
    patchVariantPicker();

    var run = function () {
      enforceNoDefaultSizeSelection();
    };

    run();

    if (window.customElements && window.customElements.whenDefined) {
      window.customElements.whenDefined('variant-picker').then(run);
    }

    document.addEventListener('change', handleVariantChange, true);
    document.addEventListener('click', handleAwaitingSizeButtonClick, true);
    document.addEventListener('click', handleStoreAvailabilityBeforeSize, true);
    document.addEventListener('shopify:section:load', function () {
      window.requestAnimationFrame(run);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
